export const bookedData = [
    {
      id: 1,
      name: "Berke Can",
      day: new Date(),
      booked: true,
      tel:"0555 4545454",
      tourname:"İzmir Kültür Turu",
     
    },
    {
      id: 2,
      name: "Caner Berk",
      day: new Date(),
      booked: true,
      tel:"0100 4545454",
      tourname:"Kapadokya Doğa Turu",
     
    },
    {
      id: 3,
      name: "Can Sözer",
      day: new Date(),
      booked: true,
      tel:"0500 4545454",
      tourname:"Doğu Anadolu Turu",
     
    }, 
   
  ];

  
export const toursData=  [
    {
      id: 1,
      tur_adi: "İzmir Kültür Turu",
      image: "https://image.hurimg.com/i/hurriyet/75/0x0/59311ef3c03c0e3efce6f4f4.jpg",
      ozellikler: [
        " ⏲ 3 gün 4 gece ",
        " 💸 15000 TL    ",
        " 📌 İzmir ",
        " ⭐ 5 ",
        " ✈️ Uçak "
      ]
    },
    {
      id: 2,
      tur_adi: "Kapadokya Doğa Turu",
      image: "https://image.hurimg.com/i/hurriyet/75/1110x740/59e9ad147152d83b24393916.jpg",
      ozellikler: [
        " ⏲ 4 gün 5 gece ",
        " 💸 35000 TL    ",
        " 📌 Nevşehir ",
        " ⭐ 5 ",
        " 🚌 Otobüs "
      ]
    },
    {
      id: 3,
      tur_adi: "Pamukkale Termal Turu",
      image:"https://image.hurimg.com/i/hurriyet/75/1110x740/62c958354e3fe015f00dd344.jpg",
      ozellikler: [
        " ⏲ 2 gün 2 gece ",
        " 💸 5000 TL    ",
        " 📌 Denizli ",
        " ⭐ 4 ",
        " ✈️ Uçak "
      ]
      
    },
    {
      id: 4,
      tur_adi: "Lavanta Adası ",
      image:"https://dogruhaber.com.tr/images/20/23/yozgatta-dunyanin-en-buyuk-lavanta-bahcesi-kuruldu-613ac9e0.jpg",
      ozellikler: [
        " ⏲ 1 gün 1 gece ",
        " 💸 5000 TL    ",
        " 📌 Yozgat ",
        " ⭐ 4 ",
        " 🚌 Otobüs "
      ]
    },
    {
      id: 5,
      tur_adi: "Trabzon Karadeniz Turu",
      image :"https://image.hurimg.com/i/hurriyet/75/750x422/61200d404e3fe01988b5d254.jpg",
      ozellikler: [
        " ⏲ 5 gün 6 gece ",
        " 💸 55000 TL    ",
        " 📌 Antalya ",
        " ⭐ 5 ",
        " ✈️ Uçak "
      ]
    },
    {
      id: 6,
      tur_adi: "Doğu Anadolu Turu",
      image:"https://www.noktaturizm.com.tr/images/tour/634_b.jpg",
      ozellikler: [
        " ⏲ 4 gün 5 gece ",
        " 💸 25000 TL    ",
        " 📌 Erzurum Kars Ağrı ",
        " ⭐ 4-5 ",
        " 🚌 Tren "
      ]
    },
    {
      id: 7,
      tur_adi: "Antalya Plaj Keyfi",
      image: "https://image.hurimg.com/i/hurriyet/75/750x422/64fe1fb94e3fe02dc0198a7a.jpg",
      ozellikler: [
        " ⏲ 5 gün 6 gece ",
        " 💸 55000 TL    ",
        " 📌 Antalya ",
        " ⭐ 5 ",
        " ✈️ Uçak "
      ]
    },
    {
      id: 8,      
      tur_adi: "Bodrum Yaz Tatili",
      image:"https://image.hurimg.com/i/hurriyet/75/1200x675/59772e93c03c0e426812423d.jpg",
      ozellikler: [
        " ⏲ 5 gün 6 gece ",
        " 💸 55000 TL    ",
        " 📌 Muğla",
        " ⭐ 5 ",
        " ✈️ Uçak "
      ]
    },
    {
      id: 9,
      tur_adi: "Safranbolu Tarihi Tur",
      image:"https://www.esentour.com/uploads/turResimleri/esentour-zonguldak-amasra-safranbolu-turu-2-922.jpg",
      ozellikler: [
        " ⏲ 2 gün 3 gece ",
        " 💸 15000 TL    ",
        " 📌 Karabük",
        " ⭐ 4 ",
        " 🚌 Otobüs"
      ]
    },
    {
      id: 10,
      tur_adi: "Güneydoğu Turu",
      image:"https://www.carpediemturizm.com/resimler/turlar/0Mardin.jpeg",
      ozellikler: [
        " ⏲ 4 gün 5 gece ",
        " 💸 35000 TL    ",
        " 📌 Mardin ",
        " ⭐ 4  ",
        " ✈️ Uçak "
      ]
    }
  ]
  